import About from '../components/About';
import Services from '../components/Services';
import Contact from '../components/Contact';
import GalleryComponent from './Gallery.js';

function Main() {
  return (
    <>
      <main>
        <About />
        <Services />
        <GalleryComponent />
        <Contact />
      </main>
    </>
  );
}
export default Main;
